export default "__VITE_ASSET__gV2XAy_b__"